export default {
  control: {
    backgroundColor: "#fff",
    fontWeight: "normal",
  },

  "&multiLine": {
    control: {
      maxHeight: 100,
    },
    highlighter: {
      padding: 9,
      maxHeight: 90,
      overflow: "auto",
    },
    input: {
      padding: 10,
      paddingRight: 34,
      borderWidth: 2,
      borderColor: "rgba(81, 205, 160, 0.7)",
      borderRadius: 20,
      overflowY: "auto",
    },
  },

  "&singleLine": {
    display: "inline-block",
    width: 180,

    highlighter: {
      padding: 1,
    },
    input: {
      padding: 1,
      // border: "2px inset",
    },
  },

  suggestions: {
    list: {
      backgroundColor: "white",
      fontSize: 14,
      maxHeight: "150px",
      overflow: "auto",
    },
    item: {
      padding: "5px 15px",
      "&focused": {
        backgroundColor: "rgba(81, 205, 160,0.2)",
      },
    },
  },
};
